import 'css-chunksrc/client/pages/projectPage/budgetPage/costsBreakdownByResourceType/graph/styles.scss';export default {
  "graph": "_graph_140mw_1",
  "progressBar": "_progressBar_140mw_5",
  "bar": "_bar_140mw_11",
  "progress": "_progress_140mw_5",
  "icon": "_icon_140mw_22",
  "clock": "_clock_140mw_31"
};